import { gql } from '@apollo/client';

export const FETCH_LMI_ZONE_LOOKUP = gql`
  query Flex_FetchLmiZoneLookup(
    $utilityAccountId: Int!
    $street: String
    $city: String
    $state: String
    $zipCode: String
  ) {
    utilityAccount(id: $utilityAccountId) {
      lmiZoneLookup(street: $street, city: $city, state: $state, zipCode: $zipCode) {
        isInLmiArea
        isInCensusTract
        lmiZoneArea {
          dacZone
          empowerZone
        }
        isAddressPresent
        error
      }
    }
  }
`;
